import { ReactNode } from 'react'
import sharedStyles from '../../landing-feature-store-page.module.css'
import { StoreCtaButton } from '../cta-button'

import styles from './store-intro.module.css'

export interface StoreIntroProps {
  title: string
  introText: ReactNode
  slug: string
  storeName: string
}
export const StoreIntro = ({
  introText,
  title,
  slug,
  storeName,
}: StoreIntroProps) => (
  <section className={styles.introSectionWrapper}>
    <h2 className={sharedStyles.heading}>{title}</h2>
    <div className={styles.storeIntroText}>{introText}</div>
    <div className={styles.introButton}>
      <StoreCtaButton
        slug={slug}
        storeName={storeName}
        trackEventTitle={'Intro section'}
      />
    </div>
  </section>
)
